<template>
  <div>
    <PageLoader v-bind:storage="appLoading" v-bind:contain="false" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" :color="snackBarColor" right timeout="2000">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap pt-5 v-if="productDetails">
      <v-flex xs12>
        <v-layout wrap justify-center>
          <v-flex xs12 md6 align-self-start px-md-4>
            <!--------------------- image --------------------->
            <v-layout wrap justify-center>
              <v-flex xs12 align-self-center pb-sm-15>
                <v-card flat height="100%">
                  <div v-if="availablePromoCodes" class="ribbon-2">Coupon: {{ availablePromoCodes }}</div>
                  <v-layout wrap justify-center fill-height>
                    <v-flex xs12 align-self-center pt-2 v-if="productDetails.photos && productDetails.photos.length > 0">
                      <div class="product-image-container">
                        <!-- Left Arrow -->
                        <button
                          v-if="productDetails.photos.length > 1"
                          class="img-arrow img-arrow-left"
                          @click.stop="prevImage"
                        >
                          <v-icon color="#333333" size="28">mdi-chevron-left</v-icon>
                        </button>

                        <inner-image-zoom
                          :key="curImage || productDetails.photos[0]"
                          zoomType="hover"
                          :hideHint="true"
                          :zoomPreload="true"
                          :zoomScale="1.5"
                          :src="mediaURLOld + (curImage ? curImage : productDetails.photos[0])"
                          :zoomSrc="mediaURLOld + (curImage ? curImage : productDetails.photos[0])"
                          class="custom-zoom-image"
                        >
                        </inner-image-zoom>

                        <!-- Right Arrow -->
                        <button
                          v-if="productDetails.photos.length > 1"
                          class="img-arrow img-arrow-right"
                          @click.stop="nextImage"
                        >
                          <v-icon color="#333333" size="28">mdi-chevron-right</v-icon>
                        </button>
                      </div>
                    </v-flex>
                    <v-flex xs12 align-self-center pt-6 v-else>
                      <div class="product-image-container">
                        <v-img
                          src="../../../assets/Images/noimage.png"
                          contain
                          max-height="450"
                        ></v-img>
                      </div>
                    </v-flex>
                    <!-- Thumbnails -->
                    <v-flex xs12 pb-4 pt-3 v-if="productDetails.photos && productDetails.photos.length > 1">
                      <div class="thumb-row">
                        <div
                          v-for="(item, i) in productDetails.photos"
                          :key="i"
                          class="thumb-item"
                          :class="{ 'thumb-active': (curImage || productDetails.photos[0]) === item }"
                          @click="showImage(item)"
                        >
                          <v-img
                            :src="mediaURLOld + item"
                            height="100%"
                            width="100%"
                            cover
                            alt="Thumbnail"
                          >
                            <template v-slot:placeholder><ImageLoader /></template>
                          </v-img>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
            <!-------------------------------------------------->
          </v-flex>
          <v-flex xs12 md6 pt-3>
            <v-layout wrap>
              <v-flex xs12 lg10>
                <div class="text-left">
                  <!-- Category Name -->
                  <div v-if="productDetails.categoryId" class="category-name mb-1">
                    {{ productDetails.categoryId.name }}
                  </div>

                  <!-- Product Name -->
                  <h1 class="product-title mb-2">
                    {{ productDetails.productname.toUpperCase() }}
                  </h1>

                  <!-- Ratings and Share Row -->
                  <div class="d-flex align-center justify-space-between flex-wrap py-2 mb-4">
                    <div class="d-flex align-center flex-wrap">
                      <v-rating
                        v-model="productDetails.rating"
                        background-color="#EAA108"
                        color="#F2C94C"
                        small
                        readonly
                        half-increments
                        dense
                        class="mr-2"
                      ></v-rating>
                      <span v-if="productDetails.rating > 0" class="rating-value mr-1" style="font-family: 'ibmsemibold', sans-serif; font-size: 15px; color: #1D2939;">
                        {{ productDetails.rating }}
                      </span>
                    </div>

                    <div class="d-flex align-center my-2 my-sm-0" style="gap: 12px;">
                      <!-- Wishlist Button -->
                      <v-btn
                        :ripple="false"
                        depressed
                        outlined
                        class="wishlist-btn rounded-xl"
                        :loading="wishlistLoading"
                        @click="productDetails.inWishlist == true ? removeFromWishlist() : addToWishList()"
                      >
                        <v-icon left size="20" class="mr-1">{{ productDetails.inWishlist == true ? 'mdi-bookmark' : 'mdi-bookmark-outline' }}</v-icon>
                        <span class="wishlist-btn-text">
                          {{ productDetails.inWishlist == true ? 'In Wishlist' : 'Add to wishlist' }}
                        </span>
                      </v-btn>

                      <!-- Share Button -->
                      <v-btn
                        outlined
                        fab
                        width="40"
                        height="40"
                        class="share-btn"
                        @click.stop="shareDialog = true"
                      >
                        <v-icon color="#344054" size="20">mdi-share-variant</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <v-dialog v-model="shareDialog" :width="$vuetify.breakpoint.name == 'xs'
                      ? '100vw'
                      : $vuetify.breakpoint.name == 'sm'
                        ? '50vw'
                        : $vuetify.breakpoint.name == 'md'
                          ? '40vw'
                          : $vuetify.breakpoint.name == 'lg'
                            ? '40vw'
                            : '20vw'
                    ">
                    <v-card class="rounded-xl overflow-hidden">
                      <v-layout wrap justify-center pa-4>
                        <v-flex xs12 pt-2 text-center align-self-start>
                          <span style="font-family: poppinsbold; font-size: 24px;">Share Via</span>
                        </v-flex>

                        <v-flex xs4 sm2 align-self-baseline text-left py-4 v-for="(item, i) in socialMedias" :key="i">
                          <ShareNetwork v-if="productDetails.photos" :network="item.network" :url="'https://kl06.co.in' + $route.fullPath" :title="item.network == 'messenger' || item.network == 'linkedin' ? '' : productDetails.productname" :media="mediaURLOld + productDetails.photos[0]">
                            <v-img :width="item.size" :src="getImgUrl(item.image)"></v-img>
                          </ShareNetwork>
                        </v-flex>
                        <v-flex xs12 pt-4 pb-2 px-2 class="text-center">
                          <v-btn color="#3EA56E" dark depressed class="rounded-lg px-6" style="text-transform: none; font-family: 'ibmsemibold', sans-serif;" @click="copyUrl('https://kl06.co.in' + $route.fullPath)">
                            <v-icon left size="18">mdi-content-copy</v-icon>
                            Copy URL
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-dialog>

                  <!-- Delivery info -->
                  <div class="mb-4" v-if="productDetails.modeOfDelivery">
                    <div class="d-inline-flex align-center py-2 px-4 rounded-xl"
                      style="background-color: #f0fdf4; border: 1px dashed #3ea56e;">
                      <v-icon small color="#3EA56E" class="mr-2">mdi-truck-fast-outline</v-icon>
                      <span style="font-family: 'ibmsemibold', sans-serif; font-size: 14px; color: #166534;">
                        Delivery: {{ productDetails.modeOfDelivery }}
                      </span>
                    </div>
                  </div>

                  <hr class="custom-divider mb-4" />

                  <!-- Price & Stock Row -->
                  <div class="d-flex align-center justify-space-between py-2 mb-4">
                    <div class="price-container">
                      <div class="d-flex align-baseline flex-wrap">
                        <span class="price-display">Rs. {{ productDetails.offerPrice }}</span>
                        <strike v-if="productDetails.offerPrice != productDetails.price" class="original-price ml-2">
                          Rs. {{ productDetails.price }}
                        </strike>
                        <span v-if="productDetails.offer" class="discount-badge ml-2">
                          Save {{ productDetails.offer }}%
                        </span>
                      </div>
                      <!-- <div class="tax-info mt-1">Inclusive of all taxes</div> -->
                    </div>

                    <div class="stock-status">
                      <template v-if="productDetails.quantity < productDetails.minimumOrderQuantity">
                        <span class="out-of-stock-text">
                          <v-icon small color="#D92D20" class="mr-1">mdi-close-circle-outline</v-icon>
                          Out of stock
                        </span>
                      </template>
                      <template v-else>
                        <span class="in-stock-text">
                          <v-icon small color="#12B76A" class="mr-1">mdi-check</v-icon>
                          In Stock
                        </span>
                      </template>
                    </div>
                  </div>

                  <!-- Quantity Selector Pill -->
                  <div class="mb-6" v-if="productDetails.quantity >= productDetails.minimumOrderQuantity">
                    <div class="modern-qty-selector">
                      <button class="qty-btn" @click="cartCount = cartCount - 1" :disabled="cartCount <= productDetails.minimumOrderQuantity">
                        <v-icon small color="#344054">mdi-minus</v-icon>
                      </button>
                      <div class="qty-display">
                        <span class="qty-value">{{ cartCount }}</span>
                        <span class="qty-unit">{{ productDetails.unit }}</span>
                      </div>
                      <button class="qty-btn" @click="cartCount = cartCount + 1" :disabled="cartCount >= productDetails.maxOrderQuantity || cartCount >= productDetails.quantity">
                        <v-icon small color="#344054">mdi-plus</v-icon>
                      </button>
                    </div>
                  </div>

                  <!-- Buy / Add to Cart Actions -->
                  <div class="actions-row mb-6" v-if="productDetails.quantity >= productDetails.minimumOrderQuantity">
                    <!-- Buy Now Button -->
                    <v-btn
                      :disabled="productDetails.quantity < productDetails.minimumOrderQuantity"
                      class="btn-buy-now flex-grow-1 flex-shrink-1"
                      depressed
                      @click="buyNow(productDetails._id)"
                    >
                      <v-icon left size="20" class="mr-1">mdi-cart-outline</v-icon>
                      <span>Buy now</span>
                    </v-btn>

                    <!-- Add to Cart / In Cart Button -->
                    <v-btn
                      v-if="productDetails.inCart == true"
                      class="btn-in-cart flex-grow-1 flex-shrink-1"
                      depressed
                      outlined
                      @click="removeCart()"
                    >
                      <v-icon left size="20" class="mr-1">mdi-check</v-icon>
                      <span>In Cart</span>
                    </v-btn>
                    <v-btn
                      v-else
                      :disabled="productDetails.quantity < productDetails.minimumOrderQuantity"
                      class="btn-add-to-cart flex-grow-1 flex-shrink-1"
                      depressed
                      outlined
                      @click="add(productDetails._id)"
                    >
                      <v-icon left size="20" class="mr-1">mdi-cart-outline</v-icon>
                      <span>Add to cart</span>
                    </v-btn>
                  </div>
                </div>

                  <!-- Variants Section -->
                  <div class="mb-6 mt-2" v-if="productDetails.variants && productDetails.variants.length > 0">
                    <div class="d-flex align-center mb-3">
                      <span style="font-family: 'ibmsemibold', sans-serif; font-size: 16px; color: #101828;">Other Variants</span>
                    </div>
                    <div class="d-flex flex-wrap" style="gap: 12px;">
                      <div 
                        v-for="(variant, i) in productDetails.variants" :key="i"
                        class="variant-modern-card d-flex align-center pa-2 rounded-xl transition-swing"
                        @click="goToVariant(variant)"
                      >
                        <div class="variant-img-wrapper rounded-lg d-flex justify-center align-center mr-3 overflow-hidden">
                          <v-img 
                            v-if="variant.productId && variant.productId.photos && variant.productId.photos.length > 0"
                            :src="mediaURLOld + variant.productId.photos[0]" 
                            max-height="40" 
                            max-width="40"
                            contain
                          ></v-img>
                          <v-icon v-else size="20" color="grey lighten-1">mdi-image-off-outline</v-icon>
                        </div>
                        <div class="d-flex flex-column justify-center flex-grow-1 overflow-hidden">
                          <span class="variant-modern-name" :class="{'mb-1': variant.offerPrice || variant.price}">
                            {{ variant.variantName }}
                          </span>
                          <div class="d-flex align-center" v-if="variant.offerPrice || variant.price">
                            <span v-if="variant.offerPrice" class="variant-modern-price">
                              Rs. {{ variant.offerPrice }}
                            </span>
                            <strike v-if="variant.price && variant.offerPrice != variant.price" class="variant-modern-strike ml-1">
                              Rs. {{ variant.price }}
                            </strike>
                          </div>
                        </div>
                        <div class="ml-2 pr-1 d-flex align-center">
                          <v-icon color="#98A2B3" size="20" class="variant-chevron">mdi-chevron-right</v-icon>
                        </div>
                      </div>
                    </div>
                  </div>


                <v-layout wrap>
                  <v-flex xs12><v-divider></v-divider></v-flex>
                  <v-flex xs12 pt-3 text-left>
                    <span class="sub" style="font-family: ibmsemibold; font-size: 18px">Description</span>
                  </v-flex>
                  <v-flex xs12 text-left v-if="productDetails">
                    <p class="des mb-0" style="font-family: ibmlight; font-size: 14px">
                      {{ productDetails.description }}
                    </p>
                  </v-flex>
                  <v-flex xs12 pt-3 text-left v-if="productDetails.link">
                    <span class="sub" style="font-family: ibmsemibold; font-size: 18px">Link </span>
                  </v-flex>
                  <v-flex xs12 text-left v-if="productDetails.link">
                    <a :href="productDetails.link">
                      <p class="des mb-0" style="font-family: ibmlight; font-size: 14px"><v-icon
                          color="red">mdi-youtube</v-icon>
                        {{ productDetails.link }}
                      </p>
                    </a>
                  </v-flex>

                  <v-flex xs12 text-left v-if="productDetails.specifications">
                    <template>
                      <v-expansion-panels tile flat>
                        <v-expansion-panel v-for="(item, i) in 1" :key="i">
                          <v-expansion-panel-header class="pa-0">
                            <span class="sub" style="font-family: ibmsemibold; font-size: 16px">Specifications</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <span v-html="productDetails.specifications" class="des"
                              style="font-family: ibmlight; font-size: 14px"></span>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </template>
                  </v-flex>
                </v-layout>

                <v-layout wrap v-if="productDetails.sellerId">
                  <v-flex xs12 pt-3><v-divider></v-divider></v-flex>
                  <v-flex xs12 pt-5 pb-3 text-left>
                    <h3 style="font-family: ibmsemibold; font-size: 20px; color: #101828;" class="mb-4">Seller</h3>
                    <v-card flat class="pa-4 rounded-xl" style="border: 1px solid #EAECF0; cursor: pointer;" @click="$router.push('/sellerdetails/' + (productDetails.sellerId.seller.slug || productDetails.sellerId._id))">
                      <v-layout wrap align-center>
                        <v-flex xs-auto class="mr-4">
                          <v-avatar size="60" color="#E8F5E9">
                            <v-icon color="#3EA56E" size="30">mdi-store</v-icon>
                          </v-avatar>
                        </v-flex>
                        <v-flex>
                          <div style="font-family: ibmsemibold; font-size: 18px; color: #101828;">
                            {{ productDetails.sellerId.organization ? productDetails.sellerId.organization : (productDetails.sellerId.firstname + (productDetails.sellerId.lastname ? ' ' + productDetails.sellerId.lastname : '')) }}
                          </div>
                          <v-layout wrap class="mt-1 align-center">
                            <v-flex class="d-flex align-center" style="font-family: ibmregular; font-size: 14px">
                              <v-rating 
                                v-if="productDetails.sellerId.seller" 
                                v-model="productDetails.sellerId.seller.rating" 
                                background-color="yellow" 
                                color="yellow" 
                                small 
                                readonly 
                                half-increments
                                dense
                                class="mr-1">
                              </v-rating>
                              <template v-if="productDetails.sellerId.seller && productDetails.sellerId.seller.rating > 0">
                                <span style="font-family: ibmsemibold; color: #101828; font-size: 15px;" class="mr-2">{{ productDetails.sellerId.seller.rating }}</span>
                              </template>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs-auto class="text-right">
                           <v-icon color="#101828">mdi-chevron-right</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex xs12><v-divider></v-divider></v-flex>
                  <v-flex xs6 pt-3 text-left>
                    <h3>Customer Reviews</h3>
                  </v-flex>
                </v-layout>
                <v-layout wrap v-if="review.length > 0">
                  <v-flex xs12>
                    <v-card class="styl" elevation="0">
                      <v-layout wrap v-for="(item, i) in review" :key="i" pt-3>
                        <v-flex xs1 text-left>
                          <v-avatar color="grey lighten-2">
                            <v-layout wrap>
                              <v-flex align-self-center><span style="
                                    text-transform: uppercase;
                                    font-family: ibmmedium;
                                    font-size: 20px;
                                  ">{{ item.user.firstname.slice(0, 1) }}</span></v-flex>
                            </v-layout>
                          </v-avatar>
                        </v-flex>
                        <v-flex xs11 px-2 text-left>
                          <span>{{ item.user.firstname }}
                            {{ item.user.lastname }}</span><br />
                          <span>
                            <v-rating v-model="item.rating" background-color="yellow" color="yellow"
                              small readonly half-increments></v-rating></span>
                          <span class="des">
                            {{ item.comment }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout v-else justify-center>
                  <v-flex xs12 text-center align-self-center>
                    <span style="font-family: ibmregular; font-size: 18px">No reviews added yet!</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start px-2>
          <v-flex xs12 xl12 py-1 v-if="similarProducts && similarProducts.length > 0">
            <ProductsSlider v-cloak v-bind:name="'SIMILAR PRODUCTS'" v-bind:products="similarProducts"
              @stepper="winStepper" />
          </v-flex>
          <v-flex xs12 xl12 py-1 v-if="otherProductsFromSeller.length > 0">
            <ProductsSlider v-cloak v-bind:name="'OTHER PRODUCTS FROM THIS SELLER'"
              v-bind:products="otherProductsFromSeller" @stepper="winStepper" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import InnerImageZoom from "vue-inner-image-zoom";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import ProductsSlider from "./productsSlider";
export default {
  props: ["productData", "productPhotos"],
  components: {
    "inner-image-zoom": InnerImageZoom,
    ProductsSlider,
  },
  data() {
    return {
      e1: 'recent',
      cartCount: null,
      pdtId: null,
      curImage: null,
      wishlistLoading: false,
      shareDialog: false,
      similarProducts: [],
      otherProductsFromSeller: [],
      name: null,
      availablePromoCodes: null,
      socialMedias: [
        {
          network: "whatsapp",
          title: "Whatsapp",
          icon: "mdi-whatsapp",
          image: "whatsapp.jpg",
          size: "55px",
        },
        {
          network: "facebook",
          title: " Facebook",
          icon: "mdi-facebook",
          image: "fb.png",
          size: "50px",
        },
        {
          network: "twitter",
          title: " Twitter",
          icon: "mdi-twitter",
          image: "twitter.png",
          size: "50px",
        },
        {
          network: "email",
          title: "Gmail ",
          icon: "mdi-email",
          image: "gmail.png",
          size: "58px",
        },
        {
          network: "linkedin",
          title: "Linkedin ",
          icon: "mdi-linkedin",
          image: "linkedin.png",
          size: "50px",
        },
      ],
      showSnackBar: false,
      snackBarColor: "",
      ServerError: false,
      productDetails: [],
      review: [],
      photos: [],
      msg: null,
      productId: null,
      appLoading: false,
      rating: 3,
      item: [
        {
          image1: "c4.png",
        },
      ],
      images: [
        {
          image: "c2.png",
          title: "Bonsai",
          price: "80/kg",
        },
        {
          image: "c7.png",
          title: "Bonsai",
          price: "80/kg",
        },
        {
          image: "c4.png",
          title: "Bonsai",
          price: "80/kg",
        },
      ],
    };
  },
  beforeMount() {
    this.productId = localStorage.getItem("productId");
    this.getData();
    this.getPromocode();
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
  },
  watch: {
    '$route.params.name': function() {
      this.productId = localStorage.getItem("productId");
      this.getData();
      this.getPromocode();
    }
  },
  methods: {
    goToVariant(variant) {
      if (variant.productId && variant.productId.urlname) {
        this.$router.push('/productdetailview/' + variant.productId.urlname);
      } else if (variant.productId && variant.productId._id) {
        this.$router.push('/productdetailview/' + variant.productId._id);
      } else if (variant.urlname) {
        this.$router.push('/productdetailview/' + variant.urlname);
      } else if (variant.productId) {
        this.$router.push('/productdetailview/' + variant.productId);
      }
    },
    setMetaTags() {
      if (!this.productDetails) return;
      
      const pageTitle = this.productDetails.productname + " | KL-06 FARM";
      let description = this.productDetails.description || "Buy " + this.productDetails.productname + " online at KL-06 FARM.";
      
      if (description.length > 160) {
        description = description.substring(0, 157) + '...';
      }

      document.title = pageTitle;
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    copyUrl(url) {
      navigator.clipboard.writeText(url).then(() => {
        this.msg = "URL copied to clipboard";
        this.showSnackBar = true;
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    },
    winStepper(item) {
      if (item.ref == "addcart") {
        this.add(item.productId);
      }
    },
    getData() {
      this.appLoading = true;
      var headers1 = {};
      var paramName = this.$route.params.name;
      var data = {};
      if (paramName && paramName.length === 24 && /^[0-9a-fA-F]{24}$/.test(paramName)) {
        data.id = paramName;
      } else {
        data.name = paramName;
      }
      
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else data["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "POST",
        url: "/product/view",
        data: data,
        headers: headers1,
      })
        .then((response) => {
          this.productDetails = response.data.data;
          this.pdtId = response.data.data._id;
          if (response.data.promocode.length > 0) {
            this.availablePromoCodes = response.data.promocode[0].promoCode;
          }
          if (this.productDetails.photo)
            this.photos = this.productDetails.photos;
          this.cartCount = response.data.data.minimumOrderQuantity;
          console.log("min qty=", this.cartCount);
          this.getSimilar();
          this.getReview(this.pdtId);
          this.getOtherProductsFromSeller();
          this.setMetaTags();
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getPromocode() {
      this.appLoading = true;
      var headers1 = {};
      var data = {
        name: this.$route.params.name,
      };
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else data["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "get",
        url: "/product/valid/promocode/list",
        params: data,
        headers: headers1,
      })
        .then((response) => {
          this.promoCodes = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getReview(item) {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/review/productwise",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          productid: item,
        },
      })
        .then((response) => {
          this.review = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    buyNow(item) {
      this.appLoading = true;
      var headers1 = {};
      var data = {
        productId: item,
        quantity: this.cartCount,
      };
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else data["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "post",
        url: "/buynow",
        data: data,
        headers: headers1,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.$router.push('/buyNow')
          }
          this.msg = response.data.msg;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    showImage(item) {
      if (this.curImage === item) return;
      this.curImage = item;
    },
    prevImage() {
      const photos = this.productDetails.photos;
      if (!photos || photos.length <= 1) return;
      const idx = photos.indexOf(this.curImage || photos[0]);
      this.curImage = idx === 0 ? photos[photos.length - 1] : photos[idx - 1];
    },
    nextImage() {
      const photos = this.productDetails.photos;
      if (!photos || photos.length <= 1) return;
      const idx = photos.indexOf(this.curImage || photos[0]);
      this.curImage = idx === photos.length - 1 ? photos[0] : photos[idx + 1];
    },
    getImgUrl(pic) {
      return require("../../../assets/social/" + pic);
    },
    add(item) {
      var headers1 = {};
      var data = {
        productId: item,
        quantity: this.cartCount,
      };
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else data["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "post",
        url: "/cart/add",
        data: data,
        headers: headers1,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.snackBarColor = "#3EA56E";
            this.showSnackBar = true;
            this.$store.commit("changeCart", response.data.cartLength);
            this.$store.commit("changeWishlist", response.data.wishlistcount);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.snackBarColor = "#FF1313";
            this.showSnackBar = true;
          }
          this.getData();
          this.getSimilar();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeCart() {
      axios({
        method: "post",
        url: "/Cart/Remove/" + this.productId,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.$store.commit("changeCart", response.data.cartLength);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.cartCount = 1;
          }
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addToWishList() {
      this.wishlistLoading = true;
      var wishlist = {};
      wishlist["productid"] = this.productDetails._id;
      var headers1 = {};
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        wishlist["guestid"] = localStorage.getItem("guestId");
      }
      axios({
        method: "POST",
        url: "/WishList/Addorupdate",
        data: wishlist,
        headers: headers1,
      })
          .then((response) => {
            if (response.data.status) {
              this.wishlistLoading = false;
              this.$store.commit("changeWishlist", response.data.wishlistcount);
              this.$store.commit("changeCart", response.data.cartcount);
              this.msg = response.data.msg;
              this.snackBarColor = "#3EA56E";
              this.showSnackBar = true;
              this.getData();
              this.productData.isinwishlist = true;
            } else {
              this.msg = response.data.msg;
              this.snackBarColor = "#FF1313";
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.wishlistLoading = false;
            console.log(err);
          });
    },
    removeFromWishlist() {
      var product = {};
      product["productid"] = this.productDetails._id;
      this.wishlistLoading = true;
      var headers1 = {};
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        product["guestid"] = localStorage.getItem("guestId");
      }
      axios({
        method: "POST",
        url: "/WishList/Remove",
        data: product,
        headers: headers1,
      })
        .then((response) => {
          this.wishlistLoading = false;
          this.$store.commit("changeWishlist", response.data.wishlistcount);
          this.msg = response.data.msg;
          if (response.data.status) {
            this.snackBarColor = "#3EA56E";
          } else {
            this.snackBarColor = "#FF1313";
          }
          this.showSnackBar = true;
          this.getData();
          this.productData.isinwishlist = false;
        })
        .catch((err) => {
          this.wishlistLoading = false;
          console.log(err);
        });
    },
    getSimilar() {
      this.appLoading = true;
      axios({
        url: "/product/similar",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          name: this.productDetails.productname,
          productid: this.productId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.similarProducts = response.data.data;
          this.loadContent = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getOtherProductsFromSeller() {
      if (!this.pdtId) return;
      axios({
        method: "POST",
        url: "/product/other-from-seller",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          productId: this.pdtId,
          count: 10,
          page: 1,
        }
      })
        .then((response) => {
          if (response.data.status) {
            this.otherProductsFromSeller = response.data.data;
          }
        })
        .catch((err) => {
          console.log("Error fetching other products from seller:", err);
        });
    },
  },
};
</script>

<style scoped>
.category-name {
  font-family: 'ibmregular', sans-serif;
  font-size: 16px;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.product-title {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 30px;
  color: #101828;
  font-weight: 600;
  line-height: 1.25;
}

.wishlist-btn {
  border: 1px solid #D0D5DD !important;
  color: #344054 !important;
  text-transform: none !important;
  font-family: 'ibmsemibold', sans-serif !important;
  font-size: 14px !important;
  height: 40px !important;
  padding: 0 16px !important;
  background-color: #ffffff !important;
  transition: all 0.2s ease;
}

.wishlist-btn:hover {
  background-color: #F9FAFB !important;
  border-color: #98A2B3 !important;
}

.share-btn {
  border: 1px solid #D0D5DD !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
  margin: 0 !important;
  transition: all 0.2s ease;
  border-radius: 50% !important;
}

.share-btn:hover {
  background-color: #F9FAFB !important;
  border-color: #98A2B3 !important;
}

.custom-divider {
  border: 0;
  border-top: 1px solid #EAECF0;
  margin: 0;
}

.price-display {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 32px;
  color: #3EA56E;
  font-weight: 700;
  line-height: 1;
}

.original-price {
  font-family: 'ibmregular', sans-serif;
  font-size: 18px;
  color: #667085;
  margin-left: 8px;
}

.discount-badge {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 12px;
  background-color: #3EA56E;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 8px;
  align-self: center;
}

.tax-info {
  font-family: 'ibmregular', sans-serif;
  font-size: 13px;
  color: #667085;
}

.in-stock-text {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 14px;
  color: #12B76A;
  display: inline-flex;
  align-items: center;
}

.out-of-stock-text {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 14px;
  color: #D92D20;
  display: inline-flex;
  align-items: center;
}

.modern-qty-selector {
  display: flex;
  align-items: center;
  border: 1px solid #EAECF0;
  border-radius: 8px;
  width: fit-content;
  height: 44px;
  overflow: hidden;
  background-color: #FFFFFF;
}

.qty-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.qty-btn:hover:not(:disabled) {
  background-color: #F9FAFB;
}

.qty-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.qty-display {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  min-width: 90px;
  height: 100%;
  border-left: 1px solid #EAECF0;
  border-right: 1px solid #EAECF0;
}

.qty-value {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #1D2939;
  margin-right: 4px;
}

.qty-unit {
  font-family: 'ibmregular', sans-serif;
  font-size: 14px;
  color: #667085;
}

.actions-row {
  display: flex;
  gap: 16px;
  width: 100%;
}

.btn-buy-now {
  background-color: #3EA56E !important;
  color: #ffffff !important;
  border-radius: 100px !important;
  text-transform: none !important;
  font-family: 'poppinssemibold', sans-serif !important;
  font-size: 15px !important;
  height: 48px !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

.btn-buy-now:hover:not(:disabled) {
  background-color: #2e8255 !important;
}

.btn-buy-now:disabled {
  background-color: #F2F4F7 !important;
  color: #98A2B3 !important;
}

.btn-add-to-cart, .btn-in-cart {
  border: 1.5px solid #3EA56E !important;
  background-color: transparent !important;
  color: #3EA56E !important;
  border-radius: 100px !important;
  text-transform: none !important;
  font-family: 'poppinssemibold', sans-serif !important;
  font-size: 15px !important;
  height: 48px !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

.btn-add-to-cart:hover:not(:disabled), .btn-in-cart:hover {
  background-color: rgba(62, 165, 110, 0.05) !important;
}

.btn-add-to-cart:disabled {
  border-color: #EAECF0 !important;
  color: #98A2B3 !important;
}

.price {
  font-weight: bold;
}

.sub {
  font-weight: bold;
}

.viewall {
  color: grey;
  font-size: 15px;
}

.v-btn--outlined {
  border-radius: unset;
  border-color: rgb(202, 199, 199);
}

.des {
  font-size: 13px;
  color: grey;
}

.styl {
  overflow-y: auto;
  min-height: 100px;
  max-height: 270px;
}

::-webkit-scrollbar {
  width: 5px !important;
  height: 1px !important;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px grey !important;
  border-radius: 5px !important;
}

::-webkit-scrollbar-thumb {
  background: #3ea56e !important;
  border-radius: 5px !important;
}

.ribbon-2 {
  --f: 10px;
  --r: 15px;
  --t: 10px;
  color: white;
  position: absolute;
  inset: var(--t) calc(-1*var(--f)) auto auto;
  padding: 0 10px var(--f) calc(10px + var(--r));
  clip-path:
    polygon(0 0, 100% 0, 100% calc(100% - var(--f)), calc(100% - var(--f)) 100%,
      calc(100% - var(--f)) calc(100% - var(--f)), 0 calc(100% - var(--f)),
      var(--r) calc(50% - var(--f)/2));
  background: #3ea56e;
  box-shadow: 0 calc(-1*var(--f)) 0 inset #0005;
}

.variant-modern-card {
  cursor: pointer;
  border: 1px solid #EAECF0;
  background-color: #FFFFFF;
  width: 100%;
  max-width: 250px;
  min-width: 200px;
}

.variant-modern-card:hover {
  border-color: #3EA56E;
  background-color: #F0FDF4;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.08) !important;
}

.variant-img-wrapper {
  background-color: #F9FAFB;
  width: 50px;
  height: 50px;
  min-width: 50px;
  border: 1px solid #F2F4F7;
  transition: all 0.2s ease;
}

.variant-modern-card:hover .variant-img-wrapper {
  background-color: #FFFFFF;
  border-color: #D1FADF;
}

.variant-modern-name {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 14px;
  color: #344054;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
  transition: color 0.2s ease;
}

.variant-modern-card:hover .variant-modern-name {
  color: #166534;
}

.variant-modern-price {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 13px;
  color: #3EA56E;
}

.variant-modern-strike {
  font-family: 'ibmregular', sans-serif;
  font-size: 11px;
  color: #98A2B3;
}

.variant-chevron {
  transition: transform 0.2s ease, color 0.2s ease;
}

.variant-modern-card:hover .variant-chevron {
  transform: translateX(2px);
  color: #3EA56E !important;
}

.product-image-container {
  height: 480px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.15);
  transition: background 0.2s, box-shadow 0.2s;
}

.img-arrow:hover {
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

.img-arrow-left {
  left: 12px;
}

.img-arrow-right {
  right: 12px;
}

.thumb-row {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0 8px;
}

.thumb-item {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  flex-shrink: 0;
}

.thumb-item:hover {
  border-color: #a8d5b9;
  box-shadow: 0 2px 8px rgba(62,165,110,0.15);
}

.thumb-active {
  border-color: #3EA56E !important;
  box-shadow: 0 2px 12px rgba(62,165,110,0.3) !important;
}

::v-deep .custom-zoom-image {
  width: auto !important;
  max-width: 100%;
  height: 480px;
  display: block;
  margin: 0 auto;
}

::v-deep .custom-zoom-image .iiz__img {
  width: auto !important;
  max-width: 100%;
  height: 480px;
  object-fit: contain;
  display: block;
}
</style>